// extracted by mini-css-extract-plugin
export default {"toast":"SocketToast_toast__+Jdsp"};